
import { MINECRAFT_BUILD_QUESTS } from './minecraft-build';
import { COMIC_CHARACTER_QUESTS } from './comic-character';
import { GAME_DEV_QUESTS } from './game-dev';
import { LEGO_STORY_QUESTS } from './lego-story';
import { DRAWING_APPRENTICE_QUESTS } from './drawing-apprentice';
import { STANDARD_CREATOR_QUESTS } from './standard';
import { RUBE_GOLDBERG_QUESTS } from './rube-goldberg';
import { CREATIVE_STITCHER_QUESTS } from './creative-stitcher';

export const CREATOR_QUESTS = [
    ...MINECRAFT_BUILD_QUESTS,
    ...COMIC_CHARACTER_QUESTS,
    ...GAME_DEV_QUESTS,
    ...LEGO_STORY_QUESTS,
    ...DRAWING_APPRENTICE_QUESTS,
    ...STANDARD_CREATOR_QUESTS,
    ...RUBE_GOLDBERG_QUESTS,
    ...CREATIVE_STITCHER_QUESTS,
];